import { withWindowResize } from 'lib/hoc/withWindowResize';
import { sanitizeHTML } from 'utils/SecurityHelper';
import { FeaturedContentProps } from './config';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

const FeaturedContent = ({
  ctaLink,
  fileReference,
  imageMask,
  openInNewTab,
  altImageText,
  featuredContentDate,
  title,
  summaryText,
}: FeaturedContentProps) => {
  const linkClasses = classNames({
    'feature-tile': true,
    'fn_feature-tile': true,
    'feature-tile--board': true,
    'feature-tile--image-wide': true,
    'feature-tile--with-image': !!fileReference,
    [`${imageMask}`]: !!imageMask,
  });

  const [sanitisedSummaryText, setSanitisedSummaryText] = useState('');
  useEffect(() => {
    // sanitise html before render - summaryText
    setSanitisedSummaryText(sanitizeHTML(summaryText));
  }, []);

  const handleImageOnLoad = (e: any) => {
    const imageWidth = e.target.offsetWidth;
    const marginLeft = `calc(50% - ${Math.floor(imageWidth / 2)}px)`;
    e.target.style.marginLeft = marginLeft;
  };

  return (
    <>
      <div className="module module--feature-tile">
        <div className="module__content l-full-width">
          {!!ctaLink && (
            <a
              href={ctaLink}
              role="button"
              rel="noreferrer"
              className={linkClasses}
              target={openInNewTab ? '_blank' : ''}
            >
              {!!fileReference && (
                <div className="feature-tile__image-container">
                  <img
                    src={fileReference}
                    alt={altImageText}
                    className="feature-tile__image"
                    onLoad={handleImageOnLoad}
                  />
                  <span className="feature-tile__mask">&nbsp;</span>
                </div>
              )}

              <div className="feature-tile__content">
                <div className="feature-tile__date">{featuredContentDate}</div>
                <div className="feature-tile__title">{title}</div>
                <div
                  className="feature-tile__text"
                  dangerouslySetInnerHTML={{ __html: sanitisedSummaryText }}
                ></div>
              </div>
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default withWindowResize(FeaturedContent);
